import React, { useContext, useEffect } from "react";
import ConstituentButtons, { ConstituentButtonsType } from "../ConstituentButtons";
import CommonModal, { CommonModalProps } from "./CommonModal";
import { TranslationContext } from "../translation/TranslationContext";
import { logEvent, incrementMetric } from "@src/utils/logClient";
import isMobile from "@src/utils/isMobile";
import { useTeacherSignupMobileRedesign } from "@src/hooks/useTeacherSignupMobileRedesign";

const SignupModal = (props: CommonModalProps) => {
  const t = useContext(TranslationContext);
  const isTeacherSignupMobileRedesign = useTeacherSignupMobileRedesign();

  useEffect(() => {
    logEvent("externalPage.click_signup");
    incrementMetric("external_site.view_signup_modal");
  });

  return (
    <CommonModal
      modalDialogStyle={{ maxWidth: "720px !important" }}
      headerText={t.translate("components.signup_picker.as_a")}
      fullPage={isTeacherSignupMobileRedesign}
      useMobileRedesign={isTeacherSignupMobileRedesign}
      {...props}
    >
      <ConstituentButtons
        responsive
        type={ConstituentButtonsType.SIGNUP}
        buttonLocation="header"
        closeModal={props.closeModal}
        useMobileRedesign={isTeacherSignupMobileRedesign}
      />
    </CommonModal>
  );
};

export default SignupModal;
